var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { FelaTheme } from 'react-fela';
/**
 * The Provider's Consumer is for accessing theme.
 */
var ProviderConsumer = function (props) { return React.createElement(FelaTheme, __assign({}, props)); };
ProviderConsumer.propTypes = {
    render: PropTypes.func.isRequired,
};
export default ProviderConsumer;
